let reportFormLocation = {
    $canvas: $('#js-locationCanvas'),
    $input: $('#js-locationInput'),
    $query: $('#js-locationQuery'),
    geocoder: null,
    location: null,
    map: null,
    styles: [
        {
            'featureType': 'poi',
            'elementType': 'all',
            'stylers': [{'visibility': 'off'}]
        },{
            'featureType': 'road.highway',
            'elementType': 'labels',
            'stylers': [{'visibility': 'off'}]
        }
    ],

    init() {
        window.app.modules.googleMaps.load(this.initMap.bind(this))
    },

    initMap() {
        let latLng

        this.geocoder = new google.maps.Geocoder()

        this.map = new google.maps.Map(this.$canvas.get(0), {
            center: new google.maps.LatLng(52.132633, 5.291266),
            mapTypeControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            streetViewControl: false,
            styles: app.modules.mapStyles.styles,
            zoom: 7,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            }
        })

        this.marker = new google.maps.Marker({
            animation: google.maps.Animation.DROP,
            icon: {
                anchor: new google.maps.Point(15, 45),
                scaledSize: new google.maps.Size(30, 45),
                size: new google.maps.Size(60, 90),
                url: '/assets/img/marker.png'
            },
            map: this.map
        })

        if (this.$input.val() !== '') {
            latLng = this.$input.val().split(',')

            if (latLng.length === 2) {
                latLng = new google.maps.LatLng(latLng[0], latLng[1])
                this.marker.setPosition(latLng)
                this.geocodeLatLng(latLng)
            }
        }

        google.maps.event.addListener(this.map, 'click', (e) => this.geocodeLatLng(e.latLng))

        this.$query.on('keydown', (e) => {
            if (e.keyCode === 13) {
                e.preventDefault()
                this.geocodeQuery($(e.target).val())
            }
        })
    },

    geocodeLatLng: function (latLng) {
        this.geocoder.geocode({location: latLng}, (results, status) => {
            this.update(latLng, (status === google.maps.GeocoderStatus.OK) ? results : [])
        })
    },

    geocodeQuery(query) {
        this.geocoder.geocode({address: query}, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
                this.map.setZoom(14)
                this.update(results[0].geometry.location, results)
            } else {
                console.error(status)
            }
        })
    },

    update: function (latLng, results) {
        let area
        let location = {
            city: null,
            country: null,
            lat: latLng.lat(),
            lng: latLng.lng(),
            province: null
        }

        area = null
        this.marker.setPosition(latLng)
        this.marker.setMap(this.map)
        this.map.panTo(latLng)

        if (results.length) {
            results[0].address_components.forEach((component) => {
                // City
                if (component.types[0] === 'locality') {
                    location.city = {
                        name: component.long_name
                    };
                }

                // Area
                if (component.types[0] === 'administrative_area_level_2') {
                    area = component.long_name
                }

                // Province
                if (component.types[0] === 'administrative_area_level_1') {
                    location.province = {
                        name: component.long_name,
                        name_short: component.short_name
                    };
                }

                // Country
                if (component.types[0] === 'country') {
                    location.country = {
                        name: component.long_name,
                        name_short: component.short_name
                    };
                }
            })

            if (!location.city.hasOwnProperty('name') || !location.city.name) {
                if (area) {
                    location.city.name = area
                }
            }

            this.location = location
            this.$input.val(JSON.stringify(location))
        }
    }  
}

export default reportFormLocation